import React, { ReactElement } from 'react';
import { canEditBusiness } from '../../utils/accessService';
import { useTranslation } from '../../utils/useTranslation';
import { Menu, MenuItem } from '../navigation/Menu';
import { Typography } from '../typography/Typography';
import { UserUI } from '../users/types';
import { PostUI } from './types';

interface PostContextMenuProps {
    trigger: ReactElement;
    onTriggerClick?: VoidFunction;
    post: PostUI;
    user?: UserUI;
    onEdit?: VoidFunction;
    onDraft?: VoidFunction;
    onRemove?: VoidFunction;
    onPublish?: VoidFunction;
    onSubscribe: VoidFunction;
    onReport?: VoidFunction;
}

export function PostContextMenu(props: PostContextMenuProps) {
    const { trigger, post, user, onTriggerClick } = props;
    const t = useTranslation();

    return (
        <Menu trigger={trigger} onTriggerClick={onTriggerClick}>
            {canEditBusiness(post.business.id, user) && props.onEdit ? (
                <MenuItem onClick={props.onEdit}>
                    <Typography noWrap>{t('Редактировать')}</Typography>
                </MenuItem>
            ) : undefined}
            {canEditBusiness(post.business.id, user) && props.onPublish ? (
                <MenuItem onClick={props.onPublish}>
                    <Typography noWrap>{t('Опубликовать')}</Typography>
                </MenuItem>
            ) : undefined}
            {canEditBusiness(post.business.id, user) && props.onDraft ? (
                <MenuItem onClick={props.onDraft}>
                    <Typography noWrap>{t('Вернуть в черновики')}</Typography>
                </MenuItem>
            ) : undefined}
            {canEditBusiness(post.business.id, user) && props.onRemove ? (
                <MenuItem onClick={props.onRemove}>
                    <Typography noWrap>{t('Удалить')}</Typography>
                </MenuItem>
            ) : undefined}

            {!canEditBusiness(post.business.id, user) && post.business.subscribed ? (
                <MenuItem onClick={props.onSubscribe}>
                    <Typography noWrap color="error">
                        {t('Отписаться')}
                    </Typography>
                </MenuItem>
            ) : (
                <MenuItem onClick={props.onSubscribe}>
                    <Typography noWrap>{t('Подписаться')}</Typography>
                </MenuItem>
            )}
            {!canEditBusiness(post.business.id, user) && props.onReport ? (
                <MenuItem onClick={props.onReport}>
                    <Typography noWrap color="error">
                        {t('Пожаловаться')}
                    </Typography>
                </MenuItem>
            ) : undefined}
        </Menu>
    );
}
